module.exports = __webpack_public_path__ + "media/alarm.acd9901f.mp3";